import React from "react";
import {Button} from "@vkontakte/vkui";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {
    BUY_COINS_MODAL,
    GAME_FAILED_FINISH_MODAL,
    GAME_RESULTS_MODAL,
    GAME_SUCCESS_FINISH_MODAL,
    SUBSCRIBE_MISSIONS_MODAL,
    SUBSCRIBE_TOURNAMENT_MODAL,
    TOURNAMENT_GOOD_LUCK_MODAL
} from "../../routing/routing";

const MODAL_TEST_FLAG_KEY = "wordmania_modal_test_enabled";

// Показывает тестовые кнопки для открытия модальных окон
export default function ModalTestPanel() {
    const routeNavigator = useRouteNavigator();

    let isEnabled = false;
    try {
        isEnabled = localStorage.getItem(MODAL_TEST_FLAG_KEY) === "1";
    } catch (error) {
        isEnabled = false;
    }

    if (!isEnabled) {
        return null;
    }

    const modalEntries = [
        {id: GAME_RESULTS_MODAL, label: "Game results"},
        {id: GAME_SUCCESS_FINISH_MODAL, label: "Victory"},
        {id: GAME_FAILED_FINISH_MODAL, label: "Defeat"},
        {id: SUBSCRIBE_TOURNAMENT_MODAL, label: "Tournament subscription"},
        {id: SUBSCRIBE_MISSIONS_MODAL, label: "Missions subscription"},
        {id: TOURNAMENT_GOOD_LUCK_MODAL, label: "Tournament good luck"},
        {id: BUY_COINS_MODAL, label: "Buy coins"},
    ];

    return (
        <div className="w-full bg-gray-800 text-gray-400 rounded-xl p-4 border border-gray-700">
            <div className="text-sm font-semibold text-gray-300 mb-3">Modal test panel</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {modalEntries.map((modal) => (
                    <Button
                        key={modal.id}
                        size="s"
                        mode="secondary"
                        className="bg-gray-700 hover:bg-gray-600 text-gray-100 border-gray-600"
                        onClick={() => routeNavigator.showModal(modal.id)}
                    >
                        {modal.label}
                    </Button>
                ))}
            </div>
        </div>
    );
}
